import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core'
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { MatFormField, MatLabel } from '@angular/material/form-field'
import { MatIcon } from '@angular/material/icon'
import { MatInput } from '@angular/material/input'
import { NgClass } from '@angular/common'
import { MatTooltip } from '@angular/material/tooltip'
import { MatOption } from '@angular/material/core'
import { MatSelect } from '@angular/material/select'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { VehicleTypeService } from '../../../core/services/vehicle/vehicle-type/vehicle-type.service'
import { ResponseRequestModel } from '../../../core/models/response.model'

@Component({
  selector: 'form-client-search',
  imports: [
    MatFormField,
    MatIcon,
    MatInput,
    MatLabel,
    ReactiveFormsModule,
    NgClass,
    MatTooltip,
    MatOption,
    MatSelect,
    MatSlideToggleModule,
  ],
  templateUrl: './form-client-search.component.html',
  styleUrl: './form-client-search.component.scss',
})
export class FormClientSearchComponent implements OnInit, OnChanges {
  constructor(
    private formBuilder: FormBuilder,
    private vehicleTypeService: VehicleTypeService,
  ) {}

  formSearch: FormGroup = new FormGroup({})
  @Output() responseSearch = new EventEmitter()
  @Input() search: any = { type: '', search: '' }
  @Input() listSearch: any[] = []
  @Input() enablePjToggle: boolean = false
  @Input() enableVehicleTypeFilter: boolean = false
  listType: any[] = []
  listVehicleType: any[] = []

  ngOnInit() {
    this.createForm()
    this.treatmentList()
    if (this.enableVehicleTypeFilter) {
      this.getVehicleTypes()
    }
  }

  // A lista mora aqui, e não em um @Input, porque um input carregado de forma
  // assíncrona dispararia ngOnChanges e o updateSearch() limparia o texto já digitado.
  getVehicleTypes() {
    this.vehicleTypeService.listVehicleType().subscribe({
      next: (response: ResponseRequestModel) => {
        this.listVehicleType = response.data ?? []
      },
      error: (err: ResponseRequestModel) => {
        console.error(err)
      },
    })
  }

  ngOnChanges() {
    this.updateSearch()
    this.treatmentList()
  }

  updateSearch() {
    this.formSearch.get('search')?.setValue(this.search.search ?? '')
    this.formSearch.get('searchType')?.setValue(this.search.type ?? '')
  }

  createForm(): void {
    this.formSearch = this.formBuilder.group({
      searchType: [''],
      search: [''],
      isPJ: [true],
      vehicleType: [''],
    })
  }

  treatmentList() {
    this.listType = []
    if (this.listSearch.length > 0) {
      for (let i = 0; i < this.listSearch.length; i++) {
        const item = this.listSearch[i]
        if (item.visible) {
          this.listType.push(item)
        }
      }
      if (this.listType.length > 0) {
        this.formSearch.get('searchType')?.setValue(this.listType[0].id)
        this.formSearch.get('search')?.enable()
        this.formSearch.get('searchType')?.enable()
      } else {
        this.formSearch.get('search')?.disable()
        this.formSearch.get('searchType')?.disable()
      }
    }
  }

  sendSearch(search = false) {
    const data = {
      type: this.formSearch.get('searchType')?.value ?? '',
      search: this.formSearch.get('search')?.value.trim() ?? '',
      isPJ: this.formSearch.get('isPJ')?.value ?? true,
      vehicleType: this.formSearch.get('vehicleType')?.value ?? '',
    }
    if (!search) {
      this.formSearch.get('search')?.setValue('')
      this.formSearch.get('vehicleType')?.setValue('')
    }
    this.responseSearch.emit({ search: search, data: search ? data : {} })
  }

  // Com o filtro de tipo de veículo ligado dá para pesquisar só pelo tipo, sem texto.
  // Desligado, o resultado é o mesmo de antes: só busca com o campo preenchido.
  canSearch(): boolean {
    const text = this.formSearch.get('search')?.value ?? ''
    if (text != '') {
      return true
    }
    return (
      this.enableVehicleTypeFilter && !!this.formSearch.get('vehicleType')?.value
    )
  }

  checkSearch() {
    if (
      this.formSearch.get('search')!.value.trim().length > 0 &&
      this.formSearch.get('searchType')!.value
    ) {
      return true
    } else {
      return false
    }
  }

  checkForm() {
    const input = this.formSearch.get('search')?.value
    if (input.trim().length > 3) {
      // if (input.trim().length == 0 || input.trim().length > 3) {
      return true
    } else {
      return false
    }
  }
}
